export default __webpack_public_path__ + "static/media/Mastercard-Color.46f636b7.svg";